import React from 'react';
import { SvgIcon } from '@mui/material';

const SVG = ({
  id = 'documents',
  style = {},
  fill = '#9192a4',
  width = '100%',
  className = '',
  viewBox = '0 0 25 25',
  title = 'Documents',
}) => (
  <SvgIcon
    fill={fill}
    width={width}
    style={style}
    className={`svg ${className}`}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>
        {`
          .svg-documents-1 { fill: none; }
          .${id}.svg-fill-documents { fill: ${fill}; }
        `}
      </style>
    </defs>
    <title>{title}</title>
    <g transform="translate(-5130 -5199)">
      <g transform="translate(1526.768 11523.063)">
        <g transform="translate(3610.52 -6317.746)">
          <path
            d="M18.246,6.179l-3.58-3.554a.443.443,0,0,0-.31-.126H4.936a.436.436,0,0,0-.436.436V18.578a.436.436,0,0,0,.436.436h13a.436.436,0,0,0,.436-.436V6.483A.436.436,0,0,0,18.246,6.179ZM17.256,17.9H5.616V3.59h8.019V6.721a.436.436,0,0,0,.429.436h3.21Z"
            transform="translate(-4.5 -2.5)"
            className={`${id} svg-fill-documents`}
          />
          <path
            d="M11.872,16.678a.561.561,0,0,0,.561-.561.568.568,0,0,0-.562-.568h-3.8a.568.568,0,1,0,0,1.13Z"
            transform="translate(-5.497 -11.876)"
            className={`${id} svg-fill-documents`}
          />
          <path
            d="M14.549,11.81H8.1a.561.561,0,1,0,0,1.123h6.447a.561.561,0,1,0,0-1.123Z"
            transform="translate(-5.532 -5.66)"
            className={`${id} svg-fill-documents`}
          />
          <path
            d="M14.549,11.81H8.1a.561.561,0,1,0,0,1.123h6.447a.561.561,0,1,0,0-1.123Z"
            transform="translate(-5.532 1.736)"
            className={`${id} svg-fill-documents`}
          />
          <rect
            width="10"
            height="1.12"
            rx="0.56"
            transform="translate(2.012 8.617)"
            className={`${id} svg-fill-documents`}
          />
          <rect
            width="10"
            height="1.12"
            rx="0.56"
            transform="translate(2.012 11.082)"
            className={`${id} svg-fill-documents`}
          />
        </g>
        <path
          d="M3610.753-6301.206a.522.522,0,0,1-.521-.521v-15.812a.521.521,0,0,1,.521-.521H3623.8a.521.521,0,0,1,.521.521.521.521,0,0,1-.521.521h-12.527v15.291A.522.522,0,0,1,3610.753-6301.206Z"
          transform="translate(-1.915 -1.916)"
          className={`${id} svg-fill-documents`}
        />
        <path
          d="M3610.753-6301.206a.522.522,0,0,1-.521-.521v-15.812a.521.521,0,0,1,.521-.521H3623.8a.521.521,0,0,1,.521.521.521.521,0,0,1-.521.521h-12.527v15.291A.522.522,0,0,1,3610.753-6301.206Z"
          transform="translate(-4 -4)"
          className={`${id} svg-fill-documents`}
        />
      </g>
      <rect
        width="25"
        height="25"
        transform="translate(5130 5199)"
        fill="none"
      />
    </g>
  </SvgIcon>
);

export default SVG;
